import { render, staticRenderFns } from "./BarChatNavigation.vue?vue&type=template&id=b4c86b76&scoped=true"
import script from "./BarChatNavigation.vue?vue&type=script&lang=ts"
export * from "./BarChatNavigation.vue?vue&type=script&lang=ts"
import style0 from "./BarChatNavigation.vue?vue&type=style&index=0&id=b4c86b76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4c86b76",
  null
  
)

export default component.exports